import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	isAddingRecruit: false,
	isUpdatingRecruit: false,
	isRecruitFieldsDisabled: true,
};

const addOrUpdateRecruitReducerSlice = createSlice({
	name: 'addOrUpdateRecruitReducer',
	initialState,
	reducers: {
		setAddOrUpdateRecruit(state, action) {
			return { ...state, ...action.payload };
		},
		setUpdateRecruit(state, action) {
			const isUpdatingRecruit = !!action.payload;
			return { ...state, isUpdatingRecruit };
		},
		setViewRecruit(state, action) {
			const isRecruitFieldsDisabled = !!action.payload;
			return {
				...state,
				isRecruitFieldsDisabled,
			};
		},
	},
});

export const { setAddOrUpdateRecruit, setUpdateRecruit, setViewRecruit } =
	addOrUpdateRecruitReducerSlice.actions;
export default addOrUpdateRecruitReducerSlice.reducer;
